import { inject, Injectable } from '@angular/core';
import { UUID } from '@okcargo-apps/shared-domain';
import { ICompanyDocument } from '@okcargo-apps/shared-domain-ionic';
import { BinaryHttpRepository, DocumentQueryService } from '@okcargo-apps/shared-infrastructure';
import { PlatformFileAdapterService } from '@okcargo-apps/shared-infrastructure-ionic';
import { DocumentMetadataResponse } from '@okcargo/query-processor';

@Injectable({
  providedIn: 'root',
})
export class DownloadDocumentService {
  private readonly documentQueryService = inject(DocumentQueryService);
  private readonly binaryHttpRepo = inject(BinaryHttpRepository);
  private readonly fileAdapter = inject(PlatformFileAdapterService);

  public getDownloadDocumentURL(document: ICompanyDocument | DocumentMetadataResponse | UUID): string {
    const documentId = typeof document === 'string' ? document : document?.id;

    return this.documentQueryService.getGenericDownloadUrl(documentId);
  }

  public async downloadFile(endpoint: string, filename = 'downloaded_file'): Promise<void> {
    const isExternalUrl = endpoint.startsWith('http://') || endpoint.startsWith('https://');

    const response = isExternalUrl
      ? await this.binaryHttpRepo.fetchExternalBlob(endpoint)
      : await this.binaryHttpRepo.fetchInternalBlob(endpoint);

    if (!response?.body) {
      console.error('No se han recibido datos válidos para procesar el archivo binario.');
      return;
    }

    await this.fileAdapter.saveAndOpenFile(response.body, filename);
  }
}
